import { getDefaultStore } from 'jotai';

export function getCurrentStore() {
  return getDefaultStore();
}
